/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Anaerobic_Te_RangeInputs */

const en_exp_anaerobic_te_range = /** @type {(inputs: Exp_Anaerobic_Te_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0–0.9: No anaerobic stimulus. 1–1.9: Minor. 2–2.9: Moderate high-intensity work. 3–3.9: Significant VO2max stimulus. 4–4.9: Very high anaerobic stress. 5.0: Overreaching.`)
};

const de_exp_anaerobic_te_range = /** @type {(inputs: Exp_Anaerobic_Te_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0–0,9: Kein anaerober Reiz. 1–1,9: Gering. 2–2,9: Moderate Hochintensitätsarbeit. 3–3,9: Deutlicher VO2max-Reiz. 4–4,9: Sehr hoher anaerober Stress. 5,0: Überbelastung.`)
};

/**
* | output |
* | --- |
* | "0–0.9: No anaerobic stimulus. 1–1.9: Minor. 2–2.9: Moderate high-intensity work. 3–3.9: Significant VO2max stimulus. 4–4.9: Very high anaerobic stress. 5.0: ..." |
*
* @param {Exp_Anaerobic_Te_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_anaerobic_te_range = /** @type {((inputs?: Exp_Anaerobic_Te_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Anaerobic_Te_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_anaerobic_te_range(inputs)
	return de_exp_anaerobic_te_range(inputs)
});